<template>
    <div ref="scrollTarget"></div>
    <section style="margin-top: 30px; margin-bottom: 100px;">
        <div class="container mt-4">
            
            <div style="margin-top: 10px; font-weight: bold; font-style: italic;" class="notification is-warning">
                <p><strong>Note:</strong> Please ensure that the start or ready time is scheduled at least one hour in advance to allow the transporter sufficient time to accept your pickup request.</p>
<p><strong>Note:</strong> The time difference between the ready time and the close time must be at least 1.5 to 2 hours to ensure the transporter can process the request.</p>
<p><strong>Note:</strong> Please confirm that both the start time and ready time fall within standard working hours.</p>

            </div>

            <div class="row justify-content-center" style="margin-top: 30px;">
                <div class="col-md-8 col-sm-12 mb-4">
                    <div class="p-4 rounded text-center border">
                        <span style="font-weight: 600; color: black;">Create PICK-UP for Shipment {{
                            this.$route.params.shipment_id
                        }}</span>
                        <form @submit.prevent="CreatePICKUPSHipment" style="margin-top: 20px;">
                            <div class="form-group mb-3">
                                <div class="row">
                                    <div class="col">
                                        <label class="label-control"
                                            style="color: black; font-weight: 600; margin-bottom: 5px;">Shipping
                                            Date</label>
                                        <input type="text" class="form-control" placeholder="Ex : 2024-12-27" required
                                            v-model="shipping_date">
                                    </div>
                                    <div class="col">
                                        <label class="label-control"
                                            style="color: black; font-weight: 600; margin-bottom: 5px;">Ready Time</label>
                                        <input type="text" class="form-control" placeholder="Ex : 09:15" required
                                            v-model="ready_time">
                                    </div>
                                    <div class="col">
                                        <label class="label-control"
                                            style="color: black; font-weight: 600; margin-bottom: 5px;">Close Time</label>
                                        <input type="text" class="form-control" placeholder="Ex : 15:47" required
                                            v-model="close_time">
                                    </div>
                                    
                                </div>
                            </div>
                            <div class="text-center mt-3">
                                <button type="submit" class="btn btn-login2 me-2">Create PICK-UP</button>
                                <br>
                                <template v-if="error_message">
                                <div style="margin-top: 10px;" class="notification is-danger">
                                    <p>{{ error_message }}</p>
                                </div>
                            </template>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        </div>
    </section>
</template>


<script>
import axios from 'axios'
import { toast } from 'bulma-toast'
import 'intl-tel-input/build/css/intlTelInput.css';
import intlTelInput from 'intl-tel-input';
import Swal from 'sweetalert2'
import en from '../en.js';
import fr from '../fr.js';
import nl from '../nl.js';


export default {
    name: 'SignUp',
    mixins: [en, fr, nl],
    data() {
        return {
            sender: {},
            recipient: {},
            pickup_country_code: '',
            receiver_country_code: '',
            sender_response: {},
            shipping_date: "",
            ready_time: "",
            close_time: "",
            delivery_date: "",
            error_message: "",
            errors: []
        }
    },
    computed: {
        lang() {
            return this.$store.state.lang
        },
    },
    async mounted() {
        document.title = 'Create PICK-UP | Eurekali'
        const element = this.$refs.scrollTarget;
        element.scrollIntoView({ behavior: 'smooth' });
        window.scrollTo(0, 0);

        
    },
    methods: {
        translate(prop) {
            return this[this.lang][prop];
        },
        async CreatePICKUPSHipment() {
            this.$store.commit('setIsLoading', true)
            

            const dataserv = {
                "shipment_id": this.$route.params.shipment_id,
                "ship_date": this.shipping_date,
                "ready_time": this.ready_time,
                "close_time" : this.close_time
            }

            await axios.post('/api/v1/transporters/admin/create-pickup/', dataserv)
                .then(response => {
                    this.error_message = ""
                    this.error_message = response.data['RequestMessage']
                    if (this.error_message === "PICKUP CREATED"){
                        const toPath = this.$route.query.to || '/shipments-progress'
                    this.$router.push(toPath)
                    }
                    
                })
                .catch(error => {
                    console.log(error)
                })
            this.$store.commit('setIsLoading', false)
        },
    }
}
</script>

<style>
.btn-login2 {
    background-color: #E5097F;
    color: white;
    margin-left: 15px;
    border-radius: 20px;
    font-weight: bold;
    padding-left: 25px;
    padding-right: 25px;
}

.btn-login2:hover {
    background-color: #9b0656;
    color: white;
}
</style>